import { render } from "./Champion.vue?vue&type=template&id=4c5bb8c0&scoped=true"
import script from "./Champion.vue?vue&type=script&lang=ts"
export * from "./Champion.vue?vue&type=script&lang=ts"

import "./Champion.vue?vue&type=style&index=0&id=4c5bb8c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c5bb8c0"

export default script